import React, { FC, PropsWithChildren } from "react";
import { COLORS } from "../styles/colors";
import { Typography } from "@mui/material";
import SvgTuvDuration from "./svg/TuvDuration";

/**
 * Component that shows the TUV Logo and a desired message next to it.
 */
const DurationIconWithText: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <div>
        <SvgTuvDuration width={40} fill={COLORS.tuv_r_blue} />
      </div>
      <Typography variant="body1">{children}</Typography>
    </div>
  );
};

export default DurationIconWithText;
